<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 426 137"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :alt="$t('promo-link-logo-footer')"
    :title="$t('promo-link-logo-footer')"
    role="img"
  >
    <defs>
      <polygon
        id="path-1"
        points="0.8399 0.824 62.2049 0.824 62.2049 64.0359 0.8399 64.0359"
      />
      <polygon
        id="path-3"
        points="0.0328 0.824 61.398 0.824 61.398 64.0359 0.0328 64.0359"
      />
    </defs>
    <g
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Group-18"
        transform="translate(0.000000, -1.000000)"
      >
        <polygon
          id="Fill-1"
          :fill="color"
          points="140.3415 102.9787 140.3415 137.1757 164.3295 137.1757 164.3295 131.7037 146.3495 131.7037 146.3495 102.9787"
        />
        <polygon
          id="Fill-2"
          :fill="color"
          points="179.131 137.176 185.14 137.176 185.14 102.979 179.131 102.979"
        />
        <polygon
          id="Fill-3"
          :fill="color"
          points="226.3716 102.9787 226.3716 126.6237 208.0516 102.9787 202.4816 102.9787 202.4816 137.1757 208.3946 137.1757 208.3946 112.8467 227.2506 137.1757 232.2826 137.1757 232.2826 102.9787"
        />
        <polygon
          id="Fill-4"
          :fill="color"
          points="271.5606 102.9787 255.2926 120.1747 255.2926 102.9787 249.2816 102.9787 249.2816 137.1757 255.2926 137.1757 255.2926 127.2587 260.6176 121.7857 272.2946 137.1757 279.6216 137.1757 264.7216 117.6837 278.9866 102.9787"
        />
        <g
          id="Group-17"
          transform="translate(0.000000, 0.176000)"
        >
          <path
            id="Fill-5"
            :fill="color"
            d="M23.561,30.7154 C30.154,30.7154 35.342,28.0784 35.342,20.6934 C35.342,13.3084 30.33,10.4064 23.385,10.4064 L9.495,10.4064 L9.495,30.7154 L23.561,30.7154 Z M9.582,63.2444 L0,63.2444 L0,1.7034 L23.385,1.7034 C35.43,1.7034 44.925,7.0664 44.925,20.8694 C44.925,33.9684 35.781,39.4194 23.561,39.4194 L9.582,39.4194 L9.582,63.2444 Z"
          />
          <path
            id="Fill-7"
            :fill="color"
            d="M106.8994,29.3087 C113.4934,29.3087 118.6804,27.1107 118.6804,20.0777 C118.6804,12.9567 113.6694,10.4957 106.7234,10.4957 L92.4814,10.4957 L92.4814,29.3087 L106.8994,29.3087 Z M92.5694,63.2447 L82.9864,63.2447 L82.9864,1.7037 L106.7234,1.7037 C118.6804,1.7037 128.2624,6.4507 128.2624,20.2537 C128.2624,31.0667 121.7574,36.0787 112.9654,37.3967 C115.1634,41.0017 127.5594,59.6397 129.7574,63.2447 L119.4714,63.2447 L102.9424,38.1007 L92.5694,38.1007 L92.5694,63.2447 Z"
          />
          <g
            id="Group-11"
            transform="translate(161.000000, 0.000000)"
          >
            <mask
              id="mask-2"
              fill="white"
            >
              <use xlink:href="#path-1" />
            </mask>
            <g id="Clip-10" />
            <path
              id="Fill-9"
              :fill="color"
              d="M31.5229,55.1559 C43.2149,55.1559 52.6229,45.3089 52.6229,32.4739 C52.6229,19.8139 43.2149,9.7919 31.5229,9.7919 C19.8299,9.7919 10.5109,19.8139 10.5109,32.4739 C10.5109,45.3089 19.8299,55.1559 31.5229,55.1559 M31.5229,0.8239 C48.4899,0.8239 62.2049,15.0669 62.2049,32.4739 C62.2049,49.9689 48.4899,64.0359 31.5229,64.0359 C14.5549,64.0359 0.8399,49.9689 0.8399,32.4739 C0.8399,15.0669 14.5549,0.8239 31.5229,0.8239"
              mask="url(#mask-2)"
            />
          </g>
          <path
            id="Fill-12"
            :fill="color"
            d="M325.1162,27.9044 C326.4682,41.0284 327.3682,50.1684 328.6982,63.2444 L319.2032,63.2444 L317.3792,44.9284 M315.1592,23.2424 L296.0822,63.8594 L291.3342,63.8594 L272.2562,23.2424 C270.9372,36.6054 269.5312,49.9694 268.3012,63.2444 L258.7172,63.2444 C260.8272,42.4964 262.9372,21.6604 265.1362,0.8244 L271.2012,0.8244 L293.7082,48.7384 L316.2142,0.8244 L322.2802,0.8244 C322.4822,2.7404 322.6832,4.6564 322.8852,6.5724"
          />
          <g
            id="Group-16"
            transform="translate(364.000000, 0.000000)"
          >
            <mask
              id="mask-4"
              fill="white"
            >
              <use xlink:href="#path-3" />
            </mask>
            <g id="Clip-15" />
            <path
              id="Fill-14"
              :fill="color"
              d="M30.7158,55.1559 C42.4078,55.1559 51.8168,45.3089 51.8168,32.4739 C51.8168,19.8139 42.4078,9.7919 30.7158,9.7919 C19.0238,9.7919 9.7038,19.8139 9.7038,32.4739 C9.7038,45.3089 19.0238,55.1559 30.7158,55.1559 M30.7158,0.8239 C47.6838,0.8239 61.3988,15.0669 61.3988,32.4739 C61.3988,49.9689 47.6838,64.0359 30.7158,64.0359 C13.7478,64.0359 0.0328,49.9689 0.0328,32.4739 C0.0328,15.0669 13.7478,0.8239 30.7158,0.8239"
              mask="url(#mask-4)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'PromoLinkLogo',
  props: {
    width: {
      type: String,
      required: false,
      default: '100px'
    },
    height: {
      type: String,
      required: false,
      default: '27px'
    },
    color: {
      type: String,
      required: false,
      default: '#FFFFFF'
    }
  }
}
</script>
